module.exports = __webpack_public_path__ + "img/favicon.6f135526.svg";